import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {NavService} from "../../../services/nav.service";
import {ActivatedRoute, Router} from "@angular/router";

@Component({
    selector: 'title-back',
    templateUrl: './title-back.component.html',
    styleUrls: ['./title-back.component.scss']
})
export class TitleBackComponent implements OnInit {
    @Input() addTitle!: boolean;

    @Input() Title!: string;
    @Output() back: EventEmitter<any> = new EventEmitter();

    constructor(private navService: NavService,
                private router: Router, private route: ActivatedRoute) {
    }

    slide() {

        const queryParams = this.route.snapshot.queryParams;
        const hasQueryParams = Object.keys(queryParams).length > 0;

        if (!hasQueryParams) {
            this.navService.landingPage.subscribe(skipTutorial => {
                if (skipTutorial == true)
                    this.router.navigateByUrl(`dashboards/dashboard1`);
                else
                    this.back.emit();
            })
        } else
            this.back.emit();
    }

    ngOnInit(): void {
    }

}
